// Holds the active account id outside React so the axios base query can read it.

let _currentAccountId: string | null = null;

export const setCurrentAccountId = (id: string | null | undefined): void => {
  _currentAccountId = id || null;
};

export const getCurrentAccountId = (): string | null => _currentAccountId;
